'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRouter = require('react-router');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _NotificationNoCompany = require('./NotificationNoCompany.scss');var styles = _interopRequireWildcard(_NotificationNoCompany);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

NotificationNoCompany = function (_Component) {_inherits(NotificationNoCompany, _Component);function NotificationNoCompany() {var _temp, _this, _ret;_classCallCheck(this, NotificationNoCompany);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      closeNotification: false }, _this.


    closeNotification = function () {return _this.setState({ closeNotification: true });}, _this.
    goToCreateACompany = function () {return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/profile/my_company'));}, _temp), _possibleConstructorReturn(_this, _ret);}NotificationNoCompany.prototype.

  render = function render() {var
    translate = this.props.translate;

    var isCompanyId = (0, _get2.default)(this.props, 'user.agent_data.agency_id', false);
    var isAgent = (0, _get2.default)(this.props, 'user.is_agent', false);

    if (!this.state.closeNotification && !isCompanyId && isAgent) {
      return (
        _react2.default.createElement('div', { className: styles.wrapper },
          _react2.default.createElement('div', { className: styles.notification },
            _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.iconWrapper, 'icon icon-attention') },
              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' })),

            _react2.default.createElement('p', { className: styles.title },
              translate('notificationNoCompany', 'title')),

            _react2.default.createElement('p', { className: styles.link, onClick: this.goToCreateACompany },
              translate('notificationNoCompany', 'link'))),


          _react2.default.createElement('div', { className: styles.close, onClick: this.closeNotification },
            _react2.default.createElement('i', { className: 'icon icon-close' }))));



    }

    return null;
  };return NotificationNoCompany;}(_react.Component);


NotificationNoCompany.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  user: _propTypes2.default.object };


var mapStateToProps = function mapStateToProps(state) {return {
    locale: state.lang.locale,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    user: state.userAuthentication.data };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(NotificationNoCompany);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationNoCompany/NotificationNoCompany.js
// module id = 2698
// module chunks = 0